import { AfterContentInit, ContentChildren, QueryList, TemplateRef } from '@angular/core';
import { TemplateDirective } from './template.directive';

export class BaseTableTemplate implements AfterContentInit {
  /* get template in app-column tag */
  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;
  headerTemplate: TemplateRef<any>;
  bodyTemplate: TemplateRef<any>;
  footerTemplate: TemplateRef<any>;

  ngAfterContentInit(): void {
    this.templates.forEach(item => {
      switch (item.getType()) {
        case 'header':
          this.headerTemplate = item.template;
          break;
        case 'footer':
          this.footerTemplate = item.template;
          break;
        default:
          this.bodyTemplate = item.template;
          break;
      }
    });
  }
}
